import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlaneTopRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPaperPlaneTopRight"><Path d="M7.60428 10.8352L0.173828 3H23.7487L11.6718 23.5309L8.59709 12.5716L15.3598 8.82365L14.3903 7.07435L7.60428 10.8352Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperPlaneTopRight;
